jQuery(document).ready(function ($) {
    $('.carte').each(function () {
        var $carte = $(this);
        var mapId = $carte.attr('id');

        // SETTINGS (depuis data-* ACF)
        // Fallback : vue monde globale si aucune coordonnée/zoom n'est renseignée
        var default_lat = parseFloat(String($carte.data('lat')).replace(',', '.')) || 20;
        var default_lon = parseFloat(String($carte.data('lon')).replace(',', '.')) || 0;
        var default_zoom = parseInt($carte.data('zoom')) || 2;

        // INITIALISATION DE LA MAP
        var map = L.map(mapId, {
            zoomControl: false,
            maxBounds: [[-90, -180], [90, 180]],
            maxBoundsViscosity: 1.0,
            worldCopyJump: false
        }).setView([default_lat, default_lon], default_zoom);

        // CONTROLS EN HAUT À GAUCHE
        L.control.zoom({position: 'topleft'}).addTo(map);

        L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
            maxZoom: 16,
            noWrap: true,
            attribution: '© Esri'
        }).addTo(map);

        L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
            maxZoom: 16,
            noWrap: true,
            pane: 'shadowPane'
        }).addTo(map);

        map.on('movestart', function () {
            map.closePopup();
        });

        map.scrollWheelZoom.disable();
        map.boxZoom.disable();
        map.keyboard.disable();
        map.dragging.enable();
        map.touchZoom.enable();
        map.doubleClickZoom.enable();

        // ZOOM MOLETTE UNIQUEMENT AVEC CTRL/CMD
        $carte.on('wheel', function (e) {
            if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                map.scrollWheelZoom.enable();
                clearTimeout($carte.data('zoomTimeout'));
                var t = setTimeout(function () {
                    map.scrollWheelZoom.disable();
                }, 500);
                $carte.data('zoomTimeout', t);
            } else {
                map.scrollWheelZoom.disable();
            }
        });

        // MARKERS & CLUSTER
        var markers = [];
        var markerClusters = L.markerClusterGroup({
            iconCreateFunction: function (cluster) {
                return L.divIcon({
                    html: `
                        <div class="cluster-icon">
                            <img src="/wp-content/themes/hh/src/img/agence.svg" />
                            <span>${cluster.getChildCount()}</span>
                        </div>
                    `, className: 'custom-cluster', iconSize: [40, 40]
                });
            }
        });

        // ICÔNES PAR TERME DE TAXONOMIE (type-carto)
        function hhBuildIcon(fileName) {
            return L.icon({
                iconUrl: '/wp-content/themes/hh/src/img/' + fileName,
                iconSize: [32, 43],
                iconAnchor: [16, 43]
            });
        }

        var iconsByTypeCarto = {
            'agence-commerciale': hhBuildIcon('agence.svg'),
            'presence-commerciale': hhBuildIcon('commercial.svg'),
            'entrepot': hhBuildIcon('entrepot.svg')
        };

        // CHARGEMENT DES MARKERS
        $carte.find('> .marker').each(function () {
            var $markerEl = $(this);
            var lat = parseFloat(String($markerEl.data('lat')).replace(',', '.'));
            var lng = parseFloat(String($markerEl.data('lng')).replace(',', '.'));
            var $popupContent = $markerEl.find('.marker-popup-content');
            var popupInner = $popupContent.length ? $popupContent.html().trim() : '';

            // Slug du terme type-carto porté par le marker (ex: data-type="agence-commerciale")
            var typeSlug = $markerEl.data('type') || '';
            var markerIcon = iconsByTypeCarto[typeSlug] || SVGiconDefault;

            if (lat && lng) {
                var marker = L.marker([lat, lng], {icon: markerIcon});
                var popupHTML = popupInner
                    ? `<div class="map-popup"><div class="map-popup__txt">${popupInner}</div></div>`
                    : '';

                if (popupHTML) {
                    marker.bindPopup(popupHTML, {autoPan: false});
                    marker.off('click');

                    marker.on('click', function (e) {
                        var px = map.latLngToContainerPoint(e.latlng);
                        px.y -= map.getSize().y * 0.20;
                        var targetLatLng = map.containerPointToLatLng(px);
                        var targetZoom = map.getZoom();

                        if (map.getCenter().equals(targetLatLng)) {
                            marker.openPopup();
                        } else {
                            map.once('moveend', function () {
                                marker.openPopup();
                            });
                            map.setView(targetLatLng, targetZoom);
                        }
                    });
                } else {
                    marker.on('click', function (e) {
                        var px = map.latLngToContainerPoint(e.latlng);
                        px.y -= map.getSize().y * 0.20;
                        var newLatLng = map.containerPointToLatLng(px);
                        map.setView(newLatLng, map.getZoom());
                    });
                }

                markerClusters.addLayer(marker);
                markers.push(marker);
            }

            $markerEl.remove();
        });

        // AJOUT DU CLUSTER À LA MAP
        map.addLayer(markerClusters);

        // FORCER LA TAILLE (utile si la map était invisible au chargement)
        setTimeout(function () {
            map.invalidateSize();
        }, 300);

        // VUE GLOBALE (monde par défaut, ou vue ACF si renseignée)
        if (markers.length > 0) {
            map.setView([default_lat, default_lon], default_zoom);
        }
    });
});